import { TextInput } from "components/core";
import { FormikProps } from "formik";
import { FC } from "react";

export interface PasswordFormProps {
  form: FormikProps<any>;
}

const PasswordForm: FC<PasswordFormProps> = ({ form }) => {
  return (
    <div className="space-y-6 divide-y divide-gray-200">
      <div className="grid grid-cols-1 gap-2">
        <div>
          <TextInput
            id="password"
            label="Password"
            type="password"
            placeholder="e.g. *********"
            required={true}
            {...form}
          />
        </div>

        <div className="space-y-1 ">
          <TextInput
            id="confirmPassword"
            label="Confirm Password"
            type="password"
            placeholder="e.g. *********"
            required={true}
            {...form}
          />
        </div>
      </div>
    </div>
  );
};

export default PasswordForm;
